export default __webpack_public_path__ + "cc62d50c6b2829250295a0d090427858.pdf";